// import { AuthAPI, signOut } from "@/auth";
import { urlConfig } from '@/config';
import { toast } from '@/hooks/use-toast';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: urlConfig.paddockFxRestApiUrl,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// axiosInstance.interceptors.response.use(
//   function (response) {
//     // Any status code that lie within the range of 2xx cause this function to trigger
//     // Do something with response data
//     return response;
//   },
//   async function (error) {
//     // TODO: re-enable this when it's not too aggressive in the wrong cases
//     // where it automatically signs out the user
//     try {
//       const token = error.config.headers.Authorization;
//       await AuthAPI.validateSession(token.accessToken);
//     } catch (error) {
//       if (error instanceof AxiosError && error.response?.status === 401) {
//         console.warn("Session unauthorized", error);
//       }
//     }

//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // Do something with response error
//     return Promise.reject(error);
//   }
// );

// Response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error?.response?.status === 401) {
      console.warn('Session unauthorized', error);
      toast({
        title: 'Unauthenticated',
        description:
          'You are not authenticated. Please sign out and sign in again to continue.',
        variant: 'destructive',
      });
    }
    return Promise.reject(error);
  },
);

// DEV NOTE: for better DEV-EX when importing axios
// thus we are aliasing this as paddockAxios
export { axiosInstance as pdkAxios };
